// extracted by mini-css-extract-plugin
export default {"newIntegrationContainer":"ConnectGithub_newIntegrationContainer__Qfs0W"};